import { Component, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  PageConfigDefault,
  AllPageSizes,
  SortOrder,
} from "@app/commons/types/enums/constants.enums";
import { IDataFilter } from "@app/commons/types/interfaces/filters.interfaces";
import { getErrorMessage } from "@app/commons/utils/utils";
import { ViewConfig } from "@app/commons/utils/view-config";
import { SnackbarService } from "@app/services/snackbar.service";
import { UserService } from "@app/services/user.service";
import {
  IBot,
  IBotListResponse,
} from "@app/commons/types/interfaces/bots.interface";
import { ChatbotManagementService } from "@app/services/chatbot-management.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-chatbot-list",
  templateUrl: "./chatbot-list.component.html",
  styleUrl: "./chatbot-list.component.scss",
})
export class ChatbotListComponent {
  modalService = inject(NgbModal);

  page = PageConfigDefault.PageLimit;
  pageSize = PageConfigDefault.PageSize;
  collectionSize = 0;
  bots: IBot[] | undefined;
  viewConfig = new ViewConfig();
  allPageSizes = Object.keys(AllPageSizes).filter((key) => !isNaN(Number(key)));

  constructor(
    private chatbotManagementService: ChatbotManagementService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getBots();
  }

  getBots() {
    const filter: IDataFilter = {
      sortColumn: "name",
      sortOrder: SortOrder.ASC,
      page: this.page,
      pageSize: this.pageSize,
    };
    this.viewConfig.setLoading(true);
    this.chatbotManagementService.get(filter).subscribe({
      next: (result: IBotListResponse) => {
        this.viewConfig.setLoading(false);
        this.bots = result.data;
        this.collectionSize = result.total;
      },
      error: (e) => {
        this.viewConfig.setError(getErrorMessage(e));
      },
    });
  }

  refreshData() {
    this.getBots();
  }

  getDetails(id: string) {
    this.router.navigate(["admin/chatbot-management", id]);
  }
}
